import {DeepLinkActionBase} from '../deep-link-action-base';

export class FreePlayDeepLinkAction extends DeepLinkActionBase {
  async execute(): Promise<void> {

    this.services.logger.info("FreePlay Deeplink arrived");

    if(!this.services.user.isAuthorized){
      await this.services.user.openLogin(this.descriptor.marketingParams);
    }

    this.services.freePlay.registerActionToExecuteWhenFreePlayIsAvailable(async () => {
      if(this.services.freePlay.hasVouchers) {
        this.services.userMenu.openRewards();
      }
    });
  }
}
